import { FocusZoneMode } from '../../types';
/**
 * @specification
 * Wraps component in FocusZone allowing circular arrow key navigation through the children of the component.
 */
var gridBehavior = function (props) { return ({
    focusZone: {
        mode: FocusZoneMode.Wrap,
        props: {
            isCircularNavigation: true,
            preventDefaultWhenHandled: true,
        },
    },
}); };
export default gridBehavior;
